import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { t } from '@/utils/i18n';
import { getPrintTypesForDraft } from '@/redux/draft/getters/getPrintTypesForDraft';
import { Badge, BadgeTypes, BadgeWithTooltip } from './Badge';
import './PrintTypeSummary.scss';

interface PrintTypeSummaryProps {
  className?: string;
}

export const PrintTypeSummary: FunctionComponent<PrintTypeSummaryProps> = ({ className }) => {
  const currentPrintTypes = useSelector(getPrintTypesForDraft);

  if (currentPrintTypes.length === 0) {
    return null;
  }

  return (
    <div className={cn(className, 'printtype-summary')}>
      <strong>
        {t('general.printType')}
        :&nbsp;
      </strong>
      {currentPrintTypes.length > 1 ? (
        <BadgeWithTooltip
          type={BadgeTypes.PrintType}
          tooltip={currentPrintTypes.map((pt) => pt.name).join(', ')}
        >
          {t('productInfoPanel.mixedPrinttypeBadge')}
        </BadgeWithTooltip>
      ) : (
        <Badge type={BadgeTypes.PrintType}>{currentPrintTypes[0].name}</Badge>
      )}
    </div>
  );
};
